// import React, { useEffect, useState } from "react";
// import axios from "axios";

// export default function ManageEnrollments() {
//   const [students, setStudents] = useState([]);

//   useEffect(() => {
//     fetchStudents();
//   }, []);

//   const fetchStudents = async () => {
//     try {
//       const res = await axios.get("http://localhost:8080/api/viewStudents");
//       // Pending first
//       const sorted = res.data.sort((a,b) => {
//         if(a.status==="Pending") return -1;
//         if(b.status==="Pending") return 1;
//         return 0;
//       });
//       setStudents(sorted);
//     } catch(err) {
//       console.error(err);
//     }
//   };

  

//  const updateStatus = async (id, status) => {
//   try {
//     const data = new FormData();
//     data.append("status", status);
//     await axios.put(`http://localhost:8080/api/updateStudent/${id}`, data, {
//       headers: { "Content-Type": "multipart/form-data" }
//     });
//     fetchStudents(); // refresh list
//   } catch(err) {
//     console.error(err);
//   }
// };

//   return (
//     <div className="p-6">
//       <h1 className="text-xl font-bold mb-4">Manage Enrollments</h1>
//       <table className="w-full border">
//         <thead>
//           <tr className="bg-gray-100">
//             <th className="border p-2">Name</th>
//             <th className="border p-2">Email</th>
//             <th className="border p-2">Course</th>
//             <th className="border p-2">Status</th>
//             <th className="border p-2">Actions</th>
//           </tr>
//         </thead>
//         <tbody>
//           {students.map(student => (
//             <tr key={student._id}>
//               <td className="border p-2">{student.studentName}</td>
//               <td className="border p-2">{student.email}</td>
//               <td className="border p-2">{student.courseName}</td>
//               <td className="border p-2">{student.status}</td>
//               <td className="border p-2">
//                 {student.status==="Pending" && (
//                   <>
//                     <button onClick={()=>updateStatus(student._id,"Approved")} className="bg-green-500 text-white px-2 py-1 mr-2 rounded">Approve</button>
//                     <button onClick={()=>updateStatus(student._id,"Rejected")} className="bg-red-500 text-white px-2 py-1 rounded">Reject</button>
//                   </>
//                 )}
//               </td>
//             </tr>
//           ))}
//         </tbody>
//       </table>
//     </div>
//   );
// }
import React, { useEffect, useState } from "react";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export default function ManageEnrollments({ onStatusChange }) {
  const [students, setStudents] = useState([]);

  useEffect(() => {
    fetchStudents();
  }, []);

const fetchStudents = async () => {
  try {
    const res = await axios.get("https://expertb.codebyte.live/api/viewStudents");

    // Exclude "Faizan Ali" and students with status "Rejected"
    const filtered = res.data.filter(
      student => student.studentName !== "Faizan ALi" && student.status !== "Rejected"
    );

    // Pending first
    const sorted = filtered.sort((a, b) => {
      if (a.status === "Pending") return -1;
      if (b.status === "Pending") return 1;
      return 0;
    });

    setStudents(sorted);
  } catch (err) {
    console.error(err);
  }
};



  const updateStatus = async (id, status) => {
    try {
      const data = new FormData();
      data.append("status", status);
      await axios.put(`https://expertb.codebyte.live/api/updateStudent/${id}`, data, {
        headers: { "Content-Type": "multipart/form-data" }
      });
      toast.success(`Student ${status}!`);
      fetchStudents(); // refresh ManageEnrollments list

      if (onStatusChange) onStatusChange(); // notify parent (ViewStudents) to refresh
    } catch(err) {
      toast.error("Failed to update status.");
      console.error(err);
    }
  };

  return (
    <div className="p-6">
      <ToastContainer position="top-center" />
      <h1 className="text-xl font-bold mb-4">Manage Enrollments</h1>
      <table className="w-full border">
        <thead>
          <tr className="bg-gray-100">
            <th className="border p-2">Name</th>
            <th className="border p-2">Email</th>
            <th className="border p-2">Course</th>
            <th className="border p-2">Status</th>
            <th className="border p-2">Actions</th>
          </tr>
        </thead>
        <tbody>
          {students.map(student => (
            <tr key={student._id}>
              <td className="border p-2">{student.studentName}</td>
              <td className="border p-2">{student.email}</td>
              <td className="border p-2">{student.courseName}</td>
              <td className="border p-2">{student.status}</td>
              <td className="border p-2">
                {student.status==="Pending" && (
                  <>
                    <button
                      onClick={() => updateStatus(student._id,"Approved")}
                      className="bg-green-500 text-white px-2 py-1 mr-2 rounded"
                    >
                      Approve
                    </button>
                    <button
                      onClick={() => updateStatus(student._id,"Rejected")}
                      className="bg-red-500 text-white px-2 py-1 rounded"
                    >
                      Reject
                    </button>
                  </>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
